import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function MECSSchoolsECooking() {
  return (
    <div className="art-page">
      <SEO
        title="MECS Uganda Schools eCooking Programme — Transitioning Schools from Biomass to Electric Cooking"
        description="CIRCODU is a central implementing and research partner in the MECS Uganda Schools eCooking Programme, aimed at shifting over 140 schools from biomass to electric cooking technologies."
        keywords="eCooking, schools, Uganda, energy data, electric cooking, clean cooking, sustainable development, energy policy, CIRCODU, MECS, institutional transition, kitchen audits, energy monitoring, SKACS, School Kitchen and Cooking Study, biomass to electric cooking transition, school energy data Uganda, electric cooking in schools Uganda, clean cooking in schools Uganda, sustainable development in schools Uganda, energy policy for schools Uganda"
        url="/MECS-Uganda-Schools-eCooking-Programme-Transitioning-Schools-from-Biomass-to-Electric-Cooking"
        datePublished="2024-10-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              MECS Uganda Schools eCooking Programme
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              October 01, 2024
            </div>
            <h1 className="art-title">
              MECS Uganda Schools eCooking Programme — Transitioning Schools
              from Biomass to Electric Cooking
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                From 2024 onward, CIRCODU has been a central implementing and
                research partner in the{" "}
                <strong>MECS Uganda Schools eCooking Programme</strong> — one of
                the most ambitious institutional clean cooking programmes
                undertaken in East Africa. This multi-phase engagement spans
                feasibility assessment, technical auditing, monitoring, and
                strategic evaluation across a programme designed to shift over{" "}
                <strong>140 schools</strong> from biomass to electric cooking
                technologies.
              </p>
              <h2 className="art-subheading">Progression of the Engagement</h2>
              <ol>
                <li>
                  <strong>
                    October 2024 — School Identification and Shortlisting:
                  </strong>{" "}
                  CIRCODU developed the methodology and conducted analytical
                  work to shortlist <strong>150 high-potential schools</strong>{" "}
                  from a database of more than 1,000 surveyed institutions,
                  assessing each school's electricity access, cooking
                  infrastructure, meal volumes, financial capacity, and appetite
                  for transition.
                </li>
                <li>
                  <strong>January 2025 — Energy and Kitchen Audits:</strong>{" "}
                  Comprehensive energy and kitchen audits in the{" "}
                  <strong>143 shortlisted schools</strong>, establishing
                  technical baselines covering biomass fuel consumption, kitchen
                  infrastructure, electricity supply quality and capacity, and
                  the financial implications of transitioning to electric
                  cooking.
                </li>
                <li>
                  <strong>
                    May 2025 — Uganda Schools Electricity Upgrades:
                  </strong>{" "}
                  Support for the implementation phase across three pillars:
                  institutional transition and infrastructure development;
                  environmental and health impact measurement; and market and
                  knowledge development.
                </li>
                <li>
                  <strong>
                    September 2025 — Monitoring, Learning and Support:
                  </strong>{" "}
                  Study examining five dimensions of the schools' eCooking
                  initiative — institutional transition, operational evidence,
                  technical sustainability, market and supply chain growth, and
                  behavioural and policy impact.
                </li>
                <li>
                  <strong>February 2026 – Ongoing — SKACS:</strong>{" "}
                  Implementation of the{" "}
                  <strong>School Kitchen and Cooking Study</strong> — a
                  specialised research framework generating evidence to guide
                  the transition of large-scale institutional kitchens from
                  biomass to electric cooking, with objectives spanning evidence
                  generation, operational optimisation, and strategic scaling.
                </li>
              </ol>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's schools eCooking programme,
                contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
